import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { API_URL } from '../config';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { login, currentUser, isSuperAdmin, authError, clearAuthError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Clear auth errors when component mounts
  useEffect(() => {
    if (clearAuthError) clearAuthError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // Update error from context if available
  useEffect(() => {
    if (authError) {
      setError(authError);
    }
  }, [authError]);
  
  // Redirect if already logged in
  useEffect(() => {
    if (currentUser) {
      if (isSuperAdmin()) {
        navigate('/admin');
      } else {
        navigate('/dashboard'); // Redirect regular users to dashboard
      }
    }
  }, [currentUser, isSuperAdmin, navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setIsLoading(true);
      
      console.log(`Attempting login with email: ${email} to ${API_URL}/auth/login`);
      
      const success = await login(email, password);
      
      if (!success) {
        setError('Failed to login. Please check your credentials.');
      }
      // Redirect is handled by the useEffect watching currentUser
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to login: ' + (err.message || 'Unknown error'));
    } finally {
      setIsLoading(false);
    }
  };
  
  // Check if there's a message from redirect
  const message = location.state?.message;
  
  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={6} lg={5}>
          <Card className="shadow-lg border-0">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Welcome Back</h2>
                <p className="text-muted">Sign in to your account</p>
              </div>
              
              {error && <Alert variant="danger">{error}</Alert>}
              {message && <Alert variant="info">{message}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </Form.Group>
                
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                
                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100 py-2"
                  disabled={isLoading}
                >
                  {isLoading ? 'Signing in...' : 'Sign In'}
                </Button>
              </Form>
              
              <div className="text-center mt-4">
                <p>
                  Don't have an account? <Link to="/register">Sign up</Link>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
